import { useQuery } from "@tanstack/react-query";

import { getRanaApiV1 } from "@nens/rana/api-v1";
import { getHCCBetaApi } from "@nens/threedi/openapi-client";

const getThreediVersionQuery = () => {
  return getRanaApiV1().getQueryOptions({
    queryKey: ["hcc-status-current-version"] as const,
    queryFn: () => getHCCBetaApi().statusCurrentVersion(),
  });
};

// Returns the current HCC framework version on the backend
export const useThreediVersion = () => {
  const { data, isLoading } = useQuery(getThreediVersionQuery());
  return { threediVersion: data?.threediVersion, isLoading };
};
